import InputControl from "../../../shared/components/InputControl";

export const DenominationField = (props) => {
  return (
    <InputControl
      type="number"
      fullWidth={false}
      sx={{ maxWidth: "96px" }}
      {...props}
    />
  );
};
